var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filters_menu_checkbox_group"},[_c('OnlineFilter',{staticClass:"label_only",attrs:{"size":"s"}}),_c('RegistrationFilter',{staticClass:"label_only",attrs:{"size":"s","show-icon":false,"no-divider":true}}),_c('PayFilter',{staticClass:"label_only",attrs:{"size":"s","show-icon":false,"no-divider":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }